import { ReactComponent as Bold } from "@svgr/webpack?-svgo,+titleProp,+ref!./Bold.svg";
import { ReactComponent as Brightness } from "@svgr/webpack?-svgo,+titleProp,+ref!./Brightness.svg";
import { ReactComponent as Build } from "@svgr/webpack?-svgo,+titleProp,+ref!./Build.svg";
import { ReactComponent as Color } from "@svgr/webpack?-svgo,+titleProp,+ref!./Color.svg";
import { ReactComponent as Crop } from "@svgr/webpack?-svgo,+titleProp,+ref!./Crop.svg";
import { ReactComponent as CurrentLocation } from "@svgr/webpack?-svgo,+titleProp,+ref!./CurrentLocation.svg";
import { ReactComponent as Design } from "@svgr/webpack?-svgo,+titleProp,+ref!./Design.svg";
import { ReactComponent as Desktop } from "@svgr/webpack?-svgo,+titleProp,+ref!./Desktop.svg";
import { ReactComponent as Devices } from "@svgr/webpack?-svgo,+titleProp,+ref!./Devices.svg";
import { ReactComponent as Emoji } from "@svgr/webpack?-svgo,+titleProp,+ref!./Emoji.svg";
import { ReactComponent as Eyedropper } from "@svgr/webpack?-svgo,+titleProp,+ref!./Eyedropper.svg";
import { ReactComponent as Italic } from "@svgr/webpack?-svgo,+titleProp,+ref!./Italic.svg";
import { ReactComponent as Link } from "@svgr/webpack?-svgo,+titleProp,+ref!./Link.svg";
import { ReactComponent as Move } from "@svgr/webpack?-svgo,+titleProp,+ref!./Move.svg";
import { ReactComponent as Palette } from "@svgr/webpack?-svgo,+titleProp,+ref!./Palette.svg";
import { ReactComponent as Phone } from "@svgr/webpack?-svgo,+titleProp,+ref!./Phone.svg";
import { ReactComponent as Picture } from "@svgr/webpack?-svgo,+titleProp,+ref!./Picture.svg";
import { ReactComponent as Questions } from "@svgr/webpack?-svgo,+titleProp,+ref!./Questions.svg";
import { ReactComponent as Rotate } from "@svgr/webpack?-svgo,+titleProp,+ref!./Rotate.svg";
import { ReactComponent as Tablet } from "@svgr/webpack?-svgo,+titleProp,+ref!./Tablet.svg";
import { ReactComponent as Underline } from "@svgr/webpack?-svgo,+titleProp,+ref!./Underline.svg";
import { ReactComponent as Website } from "@svgr/webpack?-svgo,+titleProp,+ref!./Website.svg";
import { ReactComponent as Widescreen } from "@svgr/webpack?-svgo,+titleProp,+ref!./Widescreen.svg";
import { ReactComponent as Infinity } from "@svgr/webpack?-svgo,+titleProp,+ref!./Infinity.svg";
import { ReactComponent as Keyboard } from "@svgr/webpack?-svgo,+titleProp,+ref!./Keyboard.svg";
import { ReactComponent as Pin } from "@svgr/webpack?-svgo,+titleProp,+ref!./Pin.svg";
import { ReactComponent as Send } from "@svgr/webpack?-svgo,+titleProp,+ref!./Send.svg";
import { ReactComponent as Sticker } from "@svgr/webpack?-svgo,+titleProp,+ref!./Sticker.svg";
import { ReactComponent as Type } from "@svgr/webpack?-svgo,+titleProp,+ref!./Type.svg";
export const SelectorIcons = {
  Bold,
  Brightness,
  Build,
  Color,
  Crop,
  CurrentLocation,
  Design,
  Desktop,
  Devices,
  Emoji,
  Eyedropper,
  Italic,
  Link,
  Move,
  Palette,
  Phone,
  Picture,
  Questions,
  Rotate,
  Tablet,
  Underline,
  Website,
  Widescreen,
  Infinity,
  Keyboard,
  Pin,
  Send,
  Sticker,
  Type
};
export const SelectorIconNames = ["Bold", "Brightness", "Build", "Color", "Crop", "CurrentLocation", "Design", "Desktop", "Devices", "Emoji", "Eyedropper", "Italic", "Link", "Move", "Palette", "Phone", "Picture", "Questions", "Rotate", "Tablet", "Underline", "Website", "Widescreen", "Infinity", "Keyboard", "Pin", "Send", "Sticker", "Type"];